<template>
  <div id="map-view">
    <div id="amap"></div>
  </div>
</template>

<script>
import remoteLoad from "../utils/remoteLoad";
import LocalStore from "../utils/localStorge.js";
import { MAPKEY, AMAPVERSION, AMAPUIVERSION } from "../config/map.config";
import { mapActions } from "vuex";
let imgList = [
  {
    name: "farm_loc",
    src: "farm_location_active",
  },
  {
    name: "loc",
    src: "location",
  },
  {
    name: "devicebox",
    src: "devicebox",
  },
  {
    name: "deviceboxSle",
    src: "deviceboxSle",
  },
  {
    name: "soil",
    src: "soil",
  },
  {
    name: "insert",
    src: "insert",
  },
  {
    name: "weater",
    src: "weaterStation",
  },
];
imgList.forEach((item) => {
  item.base64 = require(`../assets/log-device/${item.src}.png`);
});

function getImg(name) {
  return imgList.filter((item) => item.name == name)[0].base64;
}

export default {
  name: "map-view",
  data() {
    return {
      AMapUI: null,
      AMap: null,
      map: null,
      nowClickPoint: {},
      infoWindow: null,
      // 点标记物
      markerList: [],
      // 城市行政区域查询
      cityDistrict: null,
      // 城市轮廓
      polygon: null,
      //卫星地图
      Satellite: null,
      imageLayer: null,
      imageLayerInfo: {
        bounds: [],
        url: null,
      },
    };
  },
  async mounted() {
    await remoteLoad(
      `http://webapi.amap.com/maps?v=${AMAPVERSION}&key=${MAPKEY}`
    );
    await remoteLoad(`http://webapi.amap.com/ui/${AMAPUIVERSION}/main.js`);
    await this.getFarmInfo()
      .then((data) => {
        this.$store.commit("map/setFarmInfo", data);
      })
      .catch((err) => {
        console.error(err);
      });
    await this.mapMessage()
      .then((data) => {
        this.$store.commit("map/setMapMessage", {
          lat: data.location_latitude,
          lng: data.location_longitude,
          level: data.map_level,
        });
        this.$store.commit("map/setDeviceCount", {
          onlineCount: data.online_device_count,
          sensorCount: data.sensor_device_count,
          deviceCount: data.control_device_count + data.sensor_device_count,
          autoCount: data.automation_count,
        });
      })
      .catch((error) => {
        console.log(error);
      });
    this.initMap(this.$store.state.map.map);
    this.$emit("AmapLoaded", true);
  },
  methods: {
    ...mapActions("map", [
      "mapMessage",
      "getDeviceList",
      "getRegionList",
      "getFarmInfo",
    ]),
    async initMap(map) {
      let AMap = (this.AMap = window.AMap);
      if (map.lng && map.lat) {
        this.map = new AMap.Map("amap", {
          zoom: map.level,
          center: [map.lng, map.lat],
        });
        this.map.setMapStyle("amap://styles/darkblue");
        // 自适应缩放
        this.map.setZoomAndCenter(map.level, new AMap.LngLat(map.lng, map.lat));
      } else {
        this.map = new AMap.Map("amap");
        this.map.setMapStyle("amap://styles/darkblue");
      }
      this.Satellite = new AMap.TileLayer.Satellite({
        opacity: 0.5,
        detectRetina: true,
      });
      this.Satellite.setMap(this.map);
			if(this.logIsShowMarkder){
				this.addFarmMarker()
			}
      this.Satellite.hide();
      await this.initMarkers();
      this.map.on("mousewheel", () => {
        let zoom = this.map.getZoom();
        if (
          zoom < Math.min(this.$store.state.map.map.level, 10) &&
          this.$store.state.map.isFoucs
        ) {
          this.$store.commit("map/setFoucs");
          this.imageLayer && this.imageLayer.hide();
          this.map.clearMap();
          this.map.add(
            this.creatFarmMarker(this.$store.state.map.markers.length != 0)
          );
        }
      });
      this.map.add(
        this.creatFarmMarker(this.$store.state.map.markers.length != 0)
      );
      LocalStore.get("regionIsFoucs") && this.showIcon();
      LocalStore.get("regionIsSatellite") && this.showSatelliteIcon();
      // TODO 显示传感器数据
      // i.on("click", e => {
      //   this.showInfoWindow(e);
      // });
      // this.markerList.push(i);
    },
    showInfoWindow(e) {
      let that = this;
      this.infoWindow = new this.AMap.InfoWindow({
        isCustom: true,
        content: this.$refs.info.$el,
        offset: new this.AMap.Pixel(0, -36),
      });
      this.nowClickPoint = new this.AMap.Marker({
        position: [e.lnglat.lng, e.lnglat.lat],
      });
      this.infoWindow.open(this.map, [e.lnglat.lng, e.lnglat.lat]);
    },
    handleClose() {
      this.infoWindow.close();
    },
    initImageLayer(state) {
      if (this.imageLayer) {
        this.showImageLayer(state);
        return;
      }
      var bounds = this.imageLayerInfo.bounds;
      var boundsCenter = [
        (bounds[0][0] + bounds[1][0]) / 2,
        (bounds[0][1] + bounds[1][1]) / 2,
      ];
      var imageLayer = new AMap.ImageLayer({
        url: this.imageLayerInfo.url,
        bounds: new AMap.Bounds(bounds[0], bounds[1]),
      });
      this.map.setBounds(new AMap.Bounds(bounds[0], bounds[1]));
      var zoom = this.map.getZoom();
      this.map.setZoom(zoom);
      this.imageLayer = imageLayer;
      imageLayer.hide();
      this.map.add([imageLayer]);
      setTimeout(() => {
        var res = this.getActiveBounds();
        var newY =
          boundsCenter[1] - res[1] > 0
            ? boundsCenter[1] + Math.abs(boundsCenter[1] - res[1])
            : boundsCenter[1] - Math.abs(boundsCenter[1] - res[1]);
        if (isZoom(getLeftTop(bounds), [res[2].lng, res[2].lat])) {
          zoom = zoom - 1;
        }
        var newCenter = [boundsCenter[0], newY];
        this.map.setCenter(newCenter);
        this.$store.commit("map/setImageLayer", {
          center: newCenter,
          zoom: zoom,
        });
        this.map.setZoom(zoom);
        imageLayer.show();
      }, 500);
      function getLeftTop(bounds) {
        return [bounds[0][0], bounds[1][1]];
      }
      function isZoom(imgGps, leftTopGps) {
        //严格缩放模式
        if (leftTopGps[1] - imgGps[1] >= 0 && leftTopGps[0] - imgGps[0] <= 0) {
          return false;
        } else {
          return true;
        }
        //灵活缩放模式
        if (leftTopGps[1] - imgGps[1] <= 0 && leftTopGps[0] - imgGps[0] >= 0) {
          return trues;
        } else {
          return false;
        }
      }
    },
    async initMarkers() {
      let deviceList = await this.getDeviceList();
      let regionList = await this.getRegionList();
      let that = this;
      let aMapReginList = regionList
        .sort(function (a, b) {
          return a.type - b.type;
        })
        .map((item) => {
          if (item.type == 1) {
            if (item.bg_type === 2) {
              if (item.bg_img_gps && item.bg_img_url) {
                this.imageLayerInfo = {
                  bounds: item.bg_img_gps,
                  url: item.bg_img_url,
                };
                this.$store.state.map.isImageLayer = true;
                return null;
              } else {
                return null;
              }
            } else {
              if (item.gps == null) {
                return null;
              }
              return creatFarm(item.gps);
            }
          } else {
            if (this.$store.state.map.isImageLayer) {
              return null;
            } else {
              return creatArea(
                item.gps,
                item.color,
                item.name,
                item.centre_point
              );
            }
          }
        })
        .flat(Infinity)
        .filter((item) => item);
      let aMapDeviceList = deviceList
        .map((item) => {
          if (Object.prototype.toString.call(item.gps) != "[object Array]") {
            return null;
          }
          let deviceMap = {
            1: "sensor",
            2: "weater",
            3: "soil",
            4: "insert",
            5: 'camera'
          };
          return creatDeviceMarker(
            deviceMap[item.monitor_type],
            {
              name: item.name,
              mac: item.mac,
              position: item.gps,
              monitor_type: item.monitor_type,
              id: item.id,
              class_id: item.class_id || 1,
              icon: item.icon || `https://zn-admin.oss-cn-qingdao.aliyuncs.com/device-map-marker/point_marker_${item.monitor_type}_${item.class_id || 1}.png`
            },
            that
          );
        })
        .filter((item) => item)
        .flat(Infinity);

      this.$store.commit("map/setMarkers", [
        ...aMapReginList,
        ...aMapDeviceList,
      ]);
      return;

      function creatDeviceMarker(type = "sensor", deviceInfo, that) {
        let deviceBox =
          type == "sensor"
            ? ""
            : `<div class="deviceBox" style="transform: scale(${type == 'camera' ? 0.5 : 0.8});
    transform-origin: bottom center;">
                      <img class='deviceNormal' src='${getImg("devicebox")}' />
                      <img class='deviceSle' src='${getImg("deviceboxSle")}' />
                      <img src='${deviceInfo.icon || getImg(type)}' />
                    </div>`;
        let dialogBox = `<div class="dialogBox">
                    ${
                      deviceInfo.name
                        ? "<div><span>设备名称：</span><span>" +
                          deviceInfo.name +
                          "</span></div>"
                        : ""
                    }
                      <div>
                          <span>imei：</span>
                          <span>${deviceInfo.mac}</span>
                      </div>
                    </div>`;
        let marker = new AMap.Marker(
          Object.assign(
            {},
            {
              anchor: "bottom-center",
              offset: new AMap.Pixel(0, 2),
              zIndex: 101,
            },
            {
              position: deviceInfo.position,
            },
            {
              content: `<div class='device-Box-content'>
              ${dialogBox}${deviceBox}
              <div class="twinkle blue"></div></div>`,
            }
          )
        );
        marker.on("click", function (ev) {
          that.$emit(
            "maskerClick",
            Object.assign(
              {},
              {
                type,
              },
              deviceInfo
            )
          );
        });
        return marker;
      }

      function creatArea(path, color, name, center_point) {
        return [
          new AMap.Marker({
            content: `<div class="farm-card">
                  <img src="${getImg("loc")}" />
                  <span>${name}</span>
                </div>`, // 自定义点标记覆盖物内容
            position: center_point, // 基点位置
            anchor: "bottom-center",
            offset: new AMap.Pixel(0, 30),
          }),
          new AMap.Polygon({
            path: path,
            fillColor: color, // 多边形填充颜色
            fillOpacity: 0.3,
            strokeOpacity: 0.5,
            borderWeight: 3, // 线条宽度，默认为 1
            strokeColor: color, // 线条颜色
          }),
        ];
      }

      function isPointInArea(point, area) {
        return Amap.GeometryUtil.isPointInRing(point, area);
      }

      function creatFarm(path) {
        return new AMap.Polygon({
          path: path,
          fillOpacity: 0,
          strokeOpacity: 0.6,
          strokeWeight: 3, // 线条宽度，默认为 1
          strokeColor: "#80d8ff", // 线条颜色
          extData: {
            isFarm: true,
          },
        });
      }

      function arrayToAmap(array) {
        return array.map((item) => {
          return new AMap.LngLat(item.R, item.Q);
        });
      }

      var path = [
        new AMap.LngLat(116.368904, 39.913423),
        new AMap.LngLat(116.382122, 39.901176),
        new AMap.LngLat(116.398258, 39.9046),
      ];
      var list = areaList.map((item, index) => {
        return creatArea(arrayToAmap(item), colorList[index], "农场测试");
      });

      function computeCenter1(array) {
        var lng = 0.0,
          lat = 0.0;
        array.forEach((item) => {
          lng = lng + item.lng;
          lat = lat + item.lat;
        });
        lng = lng / array.length;
        lat = lat / array.length;
        return [lng, lat];
      }

      function computeGravity(array) {
        var area = 0,
          Gx = 0,
          Gy = 0;
        array.forEach((item, index) => {
          var iLat = item.lat,
            iLng = item.lng,
            nextLat = array[(index + 1) % array.length].lat,
            nextLng = array[(index + 1) % array.length].lng;
          var temp = (iLng * nextLat - iLat * nextLng) / 2.0;
          area += temp;
          Gx += (temp * (iLat + nextLat)) / 3.0;
          Gy += (temp * (iLng + nextLng)) / 3.0;
        });
        return [Gy / area, Gx / area];
      }

      function computeCenter(array) {
        let LngLat = [],
          X = 0,
          Y = 0,
          Z = 0;
        array.forEach((item) => {
          var lng = (item.lng * Math.PI) / 180;
          var lat = (item.lat * Math.PI) / 180;
          X = X + Math.cos(lat) * Math.cos(lng);
          Y = Y + Math.cos(lat) * Math.sin(lng);
          Z = Z + Math.sin(lat);
        });
        X = X / array.length;
        Y = Y / array.length;
        Z = Z / array.length;
        var Lng = Math.atan2(Y, X);
        var Hyp = Math.sqrt(X * X + Y * Y);
        var Lat = Math.atan2(Z, Hyp);
        return [(Lng * 180) / Math.PI, (Lat * 180) / Math.PI];
      }
      this.$store.commit("map/setMarkers", [
        creatDeviceMarker(
          "soil",
          {
            position: computeCenter(arrayToAmap(farmPath)),
            // name: '12364896',
            mac: "1231231",
          },
          that
        ),
        creatFarm(arrayToAmap(farmPath)),
        ...list.flat(),
      ]);
    },
    creatFarmMarker(isRegion = false, name = "") {
      let lng = this.$store.state.map.map.lng,
        lat = this.$store.state.map.map.lat;
      if (!(lng && lat)) {
        return null;
      }
      let marker = isRegion
        ? new AMap.Marker({
            content: `<div style='cursor:pointer' class="farm-card">
                  <img style='width:21px;height:30px' src="${getImg(
                    "farm_loc"
                  )}" />
                  <span style='font-weight:initial;margin-top:2px'>${
                    this.$store.state.map.farmInfo.name || ""
                  }</span>
                </div>`, // 自定义点标记覆盖物内容
            position: new AMap.LngLat(lng, lat), // 基点位置
            anchor: "top-center",
            offset: new AMap.Pixel(0, -30),
          })
        : new AMap.Marker({
            position: new AMap.LngLat(lng, lat),
          });
      marker.on("click", (ev) => {
        this.showIcon();
      });
      return marker;
    },
    showSatelliteIcon() {
      this.$store.commit("map/setSatellite");
      if (this.$store.state.map.isSatellite) {
        this.Satellite.show();
      } else {
        this.Satellite.hide();
      }
    },
    showImageLayer(state) {
      if (!this.imageLayer) {
        return;
      }
      if (state) {
        this.map.setCenter(this.$store.state.map.imageLayer.center);
        this.map.setZoom(this.$store.state.map.imageLayer.zoom);
        this.imageLayer.show();
      } else {
        this.imageLayer.hide();
      }
    },
    showIcon() {
      let that = this;
      this.$store.commit("map/setFoucs");
      if (!this.$store.state.map.isImageLayer) {
        if (this.$store.state.map.markers.length == 0) {
          if (this.$store.state.map.isFoucs) {
            this.map.setZoom(15);
          } else {
            this.map.setZoom(this.$store.state.map.map.level);
          }
          return;
        }
      }
      this.map.clearMap();
      if (this.$store.state.map.isFoucs) {
        this.map.add(this.$store.state.map.markers);
        function getFitViewList() {
          let markerFirst = that.$store.state.map.markers[0];
          if (
            markerFirst &&
            markerFirst.w &&
            markerFirst.w.extData &&
            markerFirst.w.extData.isFarm
          ) {
            return [markerFirst];
          } else {
            return that.$store.state.map.markers;
          }
        }
        this.$store.state.map.isImageLayer
          ? this.initImageLayer(true)
          : this.map.setFitView(getFitViewList());
      } else {
				if(this.logIsShowMarkder){
					this.addFarmMarker()
					return
				}
        this.$store.state.map.isImageLayer ? this.initImageLayer(false) : "";
        let lng = this.$store.state.map.map.lng,
          lat = this.$store.state.map.map.lat;
        if (!lng || !lat) {
          return;
        }
        this.map.add(
          this.creatFarmMarker(this.$store.state.map.markers.length != 0)
        );
        this.map.setZoomAndCenter(
          this.$store.state.map.map.level,
          new AMap.LngLat(lng, lat)
        );
      }
    },
    getActiveBounds() {
      const firstChild = document.getElementsByClassName("sensor-list")[0];
      const lastChild = document.getElementsByClassName("trace")[0];
      let containerLoction = [
        new AMap.Pixel(firstChild.offsetWidth, 0),
        new AMap.Pixel(lastChild.offsetLeft, lastChild.offsetTop),
      ];
      let bounds = [
        this.map.containerToLngLat(containerLoction[0]),
        this.map.containerToLngLat(containerLoction[1]),
      ];
      // this.map.add([new AMap.Marker({
      //   position:bounds[0],
      // }), new AMap.Marker({
      //   position: bounds[1],
      // })])
      return [
        (bounds[0].lng + bounds[1].lng) / 2,
        (bounds[0].lat + bounds[1].lat) / 2,
        bounds[0],
      ];
    },
		addFarmMarker() {
				let creatFarm = (name, gps) => {
					return new AMap.Marker({
						content: `<div style='cursor:pointer' class="farm-card">
		                    <img style='width:21px;height:30px' src="${getImg('farm_loc')}" />
		                    <span style='font-weight:initial;margin-top:2px'>${name}</span>
		                  </div>`, // 自定义点标记覆盖物内容
						position: gps, // 基点位置
						anchor: 'top-center',
						offset: new AMap.Pixel(0, -30)
					})
				}
				let array = [];
				var geoCoordMap =Object.assign({},JSON.parse(`{}`),{
					"廊坊":[116.690228,39.49175],
					"丽江":[100.298626,26.824092],
					"齐齐哈尔":[123.853314,47.264336],
					"咸宁":[114.322601,29.84135],
					"赤壁":[113.900385,29.725122],
					'青岛': [120.33, 36.07],
					'攀枝花': [101.718637, 26.582347],
					'林芝': [94.36149, 29.649128],
					'重庆': [106.550464, 29.563761],
					'厦门': [118.1, 24.46],
					'太仓': [121.1, 31.45],
					'曲靖': [103.79, 25.51],
					'烟台': [121.39, 37.52],
					'福州': [119.3, 26.08],
					'湛江': [110.359377, 21.270708],
					'荣成': [122.41, 37.16],
					'连云港': [119.16, 34.59],
					'葫芦岛': [120.836932, 40.711052],
					'营口': [122.18, 40.65],
					'惠州': [114.4, 23.09],
					'吴江': [120.63, 31.16],
					'石嘴山': [106.39, 39.04],
					'沈阳': [123.38, 41.8],
					'苏州': [120.62, 31.32],
					'茂名': [110.88, 21.68],
					'嘉兴': [120.76, 30.77],
					'长春': [125.35, 43.88],
					'胶州': [120.03336, 36.264622],
					'银川': [106.27, 38.47],
					'张家港': [120.555821, 31.875428],
					'呼和浩特': [111.65, 40.82],
					'成都': [104.06, 30.67],
					'大同': [113.3, 40.12],
					'镇江': [119.44, 32.2],
					'桂林': [110.28, 25.29],
					'张家界': [110.479191, 29.117096],
					'牡丹江': [129.58, 44.6],
					'遵义': [106.9, 27.7],
					'绍兴': [120.58, 30.01],
					'扬州': [119.42, 32.39],
					'马鞍山': [118.48, 31.56],
					'徐州': [117.2, 34.26],
					'包头': [110, 40.58],
					'绵阳': [104.73, 31.48],
					'乌鲁木齐': [87.68, 43.77],
					'鞍山': [122.85, 41.12],
					'库尔勒': [86.06, 41.68],
					'安阳': [114.35, 36.1],
					'开封': [114.35, 34.79],
					'临沂': [118.35, 35.05],
					'南充': [106.110698, 30.837793],
					'哈尔滨': [126.63, 45.75],
					'济宁': [116.59, 35.38],
					'荆州': [112.239741, 30.335165],
					'宜昌': [111.3, 30.7],
					'湘潭': [112.91, 27.87],
					'金华': [119.64, 29.12],
					'岳阳': [113.09, 29.37],
					'长沙': [113, 28.21],
					'衢州': [118.88, 28.97],
					'渝中县': [104.096543, 35.852864],
					// '咸阳':[ 98.108614,36.310126],
					// '银川':[ 98.108614,36.310126],
					'西安': [108.941133, 34.410855],
					'上饶': [117.971185, 28.44442]

				})
				// console.log(Object.keys(geoCoordMap).length)
				// Object.keys(geoCoordMap).length
				Object.keys(geoCoordMap).forEach(item => {
					let obj = {}
					obj.name = item;
					obj.gps = geoCoordMap[item]
					array.push(obj)
					// console.log(item)
				})

				this.map.add(array.map(item => {
					return creatFarm(item.name, item.gps)
				}))
				this.map.setFitView()
			},
  },
};
</script>

<style scoped>
#map-view {
  width: 100%;
  height: 100%;
}

#amap {
  width: 100%;
  height: 100%;
}
</style>
